import { useEffect } from "react";
import { useDashboardUserSettingDispatch } from "../contexts/DashboardUserSettingsContext";
import { useAuthStore } from "../contexts/AuthContext";
import useCheckPermission from "../helpers/checkPermission";

// payload: DashboardId, AccountId,lastActionOn
export default function useCreateDashboardUserSettings() {
  async function createDashboardUserSetting(payload) {
    const response = await fetch(`/api/dashboardusersettings`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (response.ok) {
      let data = await response.json();
      return data;
    }
  }
  return {
    createDashboardUserSetting,
  };
}

export function useGetDashboardUserSettings() {
  const { selectedAccount, user } = useAuthStore();
  const dashboardUserSettingDispatch = useDashboardUserSettingDispatch();

  const DashViewAllPerm = useCheckPermission("dashboard.view.all")
  const DashItemIndividualPerm = useCheckPermission("dashboard.item-permission.individually-shared")
  const DashItemAccountPerm = useCheckPermission("dashboard.item-permission.shared-to-account")

  useEffect(() => {
    
    dashboardUserSettingDispatch({ type: "setIsLoadingDashboardUserSettings", payload: true });
    const controller = new AbortController();
    const { signal } = controller;
    let url;
    if(user.isSuperAdmin && !selectedAccount.id){
      url = "/api/dashboards/templates/user-settings";
    }else if((user.isSuperAdmin && selectedAccount.id) || 
        DashViewAllPerm.permitted || DashItemIndividualPerm.permitted || DashItemAccountPerm.permitted
    ){
      url = `/api/dashboards/user-settings?account=${selectedAccount.id}`;
    }else{
        dashboardUserSettingDispatch({ type: "setIsLoadingDashboardUserSettings", payload: false });
        return;
    };
    fetch(url, { signal, credentials: 'include' })
      .then((r) => {
        if (!r.ok) throw new Error("Failed to fetch dashboard user settings");
        return r.json();
      })
      .then((data) => {
        dashboardUserSettingDispatch({
          type: "setDashboardUserSettings",
          payload: data.DashboardUserSettings,
        });
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error("Error fetching dashboard user settings:", error);
        }
      })
      .finally(() => {
        dashboardUserSettingDispatch({ type: "setIsLoadingDashboardUserSettings", payload: false });
      });
    return () => {
      controller.abort();
    };
  }, [user, selectedAccount, dashboardUserSettingDispatch]);
}

export function useUpdateDashboardUserSettings() {
  const dashboardUserSettingDispatch = useDashboardUserSettingDispatch();
 
  async function updateDUS(dusList) {
    dashboardUserSettingDispatch({ type: "setIsLoadingDashboardUserSettings", payload: true });
    const response = await fetch(
      `/api/dashboards/${dusList[0].DashboardId}/user-settings`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dusList),
      }
    );
    if (response.ok) {
      let data = await response.json();
      dashboardUserSettingDispatch({ type: "updateDashboardUserSettings", payload: data.DashboardUserSettings });
      dashboardUserSettingDispatch({ type: "setIsLoadingDashboardUserSettings", payload: false });
      return data
    }
  };

  return {updateDUS};
}